<template>
  <footer class="mobile-footer">
    <FoldMenu class="footer-fold-menu" gap="20px" :menu="menu"></FoldMenu>
    <div class="footer-link">
      <a v-for="icon in FooterIcon" :key="icon.src" :href="icon.link">
        <img class="footer-icon" :src="icon.src">
      </a>
    </div>
    <div class="footer-copyright">
      © 2018 - {{ year }} Ontology. All rights reserved
    </div>
  </footer>
</template>
<script>
import FoldMenu from "./FoldMenu.vue";
import { FooterMenu, TopMenu, FooterIcon } from "../constant";
export default {
    components: { FoldMenu },
    data() {
      return {
        FooterIcon,
        year: new Date().getFullYear()
      }
    },
    computed: {
      menu() {
        return [...FooterMenu, ...TopMenu]
      }
    }
}
</script>

<style lang="scss">
.mobile-footer {
  position: relative;
  background-color: #051432;

  .lg-font {
    font-size: 18px;
    line-height: 24px;
  }
  .footer-link {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 55px;
    row-gap: 16px;
    padding: 0 32px;
  }
  .footer-icon {
    height: 18px;
    width: 18px;
  }
  .footer-copyright {
    margin-top: 16px;
    font-size: 14px;
    line-height: 15px;
    color: rgba(255,255,255,0.4);
    padding-bottom: 60px;
  }
}
.footer-fold-menu {
  padding: 60px 20px;
  right: 0;
}
</style>